export default "__VITE_ASSET__GCsQ_fo3__"